import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { SlickDialogComponent } from "@slick-components";

@Component({
	selector: "site-log-dialog",
	templateUrl: "site-log-dialog.component.html"
})
export class SiteLogDialogComponent {
	@Output() onSaved = new EventEmitter<void>();
	@ViewChild("siteLogDialog", { static: true }) siteLogDialog: SlickDialogComponent;

	customerId: number;
	jobId: number;
	appointmentId: number;
	isOpen = false;

	openDialog(customerId: number, jobId: number, appointmentId: number) {
		this.customerId = customerId;
		this.jobId = jobId;
		this.appointmentId = appointmentId;
		this.isOpen = true;
		this.siteLogDialog.showDialog();
	}

	closeDialog() {
		if (!this.isOpen)
			return;

		this.isOpen = false;
		this.customerId = null;
		this.jobId = null;
		this.appointmentId = null;
		this.siteLogDialog.hideDialog();
	}
}
